module.exports = __webpack_public_path__ + "fonts/icomoon.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icomoon/icomoon.eot
// module id = GfPJ
// module chunks = 1